module.exports = __webpack_public_path__ + "img/QuentinVeillas.873ebe45.png";